module.exports = __webpack_public_path__ + "img/10.6aaeb515.png";